import { Input } from "antd";
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const InputPhone = forwardRef((props, ref) => {

  return (
    <PhoneInput
      country={'ru'}
      preferredCountries={['ru', 'by', 'ua', 'kz', 'uz']}
      {...props}
    />
  );
});


export default InputPhone;
